var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { useState } from "react";
import { Box, Flex, Label, Radio as ThemeRadio } from "theme-ui";
import { FormVariants, UserInputStackLineItem, UserInputStack } from "../../index";
import { randomId } from "../../utils";
export const Radio = (_a) => {
    var { id, children, ref } = _a, props = __rest(_a, ["id", "children", "ref"]);
    return (_jsxs(Label, { htmlFor: id, sx: {
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            color: "black.1",
            variant: "text.label2"
        }, children: [_jsx(ThemeRadio, Object.assign({ name: props.name, id: id, sx: { variant: `forms.${FormVariants.radio}` } }, props)), children] }));
};
export const RadioGroup = props => _jsx(UserInputStack, { children: props.children });
export const RadioCard = (_a) => {
    var { variant = FormVariants.radio, checked = false, defaultChecked = false, ref, children } = _a, props = __rest(_a, ["variant", "checked", "defaultChecked", "ref", "children"]);
    const [labelClicked, setLabelClicked] = useState(false);
    if (!props.id) {
        props.id = randomId();
    }
    return (_jsx(UserInputStackLineItem, { sx: {
            padding: 0,
            ":focus-within": {
                outlineStyle: labelClicked ? "none" : "solid",
                outlineWidth: 1
            }
        }, children: _jsxs(Label, { htmlFor: props.id, sx: {
                padding: 16,
                variant: `forms.${FormVariants.label}`,
                cursor: "pointer",
                display: "flex",
                alignItems: "center"
            }, onMouseUp: () => setLabelClicked(true), onBlur: () => setLabelClicked(false), children: [_jsx("div", { sx: { marginRight: 8 }, children: _jsx(ThemeRadio, Object.assign({ id: props.id, name: props.name, 
                        //defaultChecked={defaultChecked}
                        checked: checked, sx: { variant: `forms.${FormVariants.radio}` } }, props)) }), _jsx(Flex, { sx: { width: "100%", alignItems: "inherit" }, children: children })] }) }));
};
export const RadioCardText = props => (_jsx(Box, Object.assign({ sx: { marginRight: "auto", display: "flex", flexDirection: "column" } }, props)));
export const RadioCardImage = props => _jsx(Box, Object.assign({ sx: { marginLeft: "auto" } }, props));
//# sourceMappingURL=Radio.js.map